import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {GenericModal} from '@techsee/techsee-ui-common/lib/modals/generic';
import {SendTextDialogController} from './SendTextDialog.controller';
import {SendTextDialogHeader} from './components/SendTextDialogHeader';
import {SendTextDialogContent} from './components/SendTextDialogContent';
import {SendTextDialogToolbar} from './components/SendTextDialogToolbar';
import './SendTextDialog.scss';

interface SendTextDialogProps {
    ctrl: SendTextDialogController;
}

@observer
export class SendTextDialog extends TechseeBaseComponent<SendTextDialogProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        if (!ctrl.isVisible) {
            return <></>;
        }

        return (
            <GenericModal
                className='send-text-modal'
                header={() => <SendTextDialogHeader ctrl={ctrl} />}
                content={() => <SendTextDialogContent ctrl={ctrl} />}
                toolbar={() => <SendTextDialogToolbar ctrl={ctrl} />}
                onHideHandler={ctrl.close}
                show={ctrl.isVisible}
                isCloseVisible={true}
            />
        );
    }
}
